<template>
	<v-card>
		<v-card-title>
			<span class="headline">اطلاعات صورتحساب</span>
			<v-spacer />
			<v-btn @click="$emit('close')" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>

		<v-divider></v-divider>

		<v-card-text>
			<v-card-subtitle class="pt-4 text-center ">
				شما در حال مشاهده صورتحساب مشتری با مشخصات زیر می باشید:
				<v-card color="#eee" elevation="0" class="pa-2 my-2">
					<div class="secondary--text mb-2" style="font-size: 14pt;">{{ localData.member.fullName }}</div>
					<div class="grey--text">کد ملی:</div>
					<div class="secondary--text" style="font-size: 14pt;">{{ localData.member.nationalCode }}</div>
				</v-card>
				<v-card color="#eee" elevation="0" class="pa-2 my-2">
					<div class="grey--text">مشخصات نماینده:</div>
					<div class="secondary--text" style="font-size: 14pt;">{{ localData.agent ? localData.agent.businessName : '' }}</div>
				</v-card>
			</v-card-subtitle>
			<v-form ref="formFactor" @submit.prevent="submitFactor">
				<v-row>
					<v-col cols="12" class="pt-1">
						<div class="">
							<div class="mb-1">
								تاریخ صورتحساب:
								<span class="mr-1" v-if="![USER_TYPES.admin].includes(userType)">{{ localData.createAt_Persian.date }}</span>
							</div>
							<date-picker v-if="[USER_TYPES.admin].includes(userType)" ref="regDate2" v-model="localData.createAt" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" clearable auto-submit :rules="[() => localData.regDate2 === '' || 'تاریخ عضویت را به صورت صحیح وارد کنید']" />
							<div class="red--text">
								{{ datePickerValidatioin }}
							</div>
						</div>
					</v-col>
					<v-col cols="12" class="py-0">
						<v-text-field outlined class="align-center center-input" :disabled="true" v-model="localData.code" :label="'شماره سیستمی'" :error-messages="errorMessages" />
					</v-col>
					<v-col cols="12" class="py-0">
						<v-text-field outlined class="align-center center-input" v-model="localData.userCode" label="شماره فرعی صورتحساب (اختیاری)" :error-messages="errorMessages" />
					</v-col>
					<v-col cols="12" class="py-0">
						<v-text-money outlined class="align-center center-input" v-model="localData.amount" label="مبلغ صورتحساب (تومان)" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']" required />
					</v-col>
					<v-col cols="12" class="pb-0 pt-6">
						<v-textarea outlined class="" v-model="localData.description" label="شرح اقلام صورتحساب" :error-messages="errorMessages" :rules="[() => !!localData.description || 'شرح صورتحساب را وارد کنید']" required />
					</v-col>
					<v-col cols="12" class="">
						<v-card color="#eee" class="px-2 d-flex">
							<v-text-field ref="mobile" :disabled="true" v-model="localData.member.mobile" maxlength="11" label="موبایل" />
							<!-- <div v-if="[USER_TYPES.admin].includes(userType)" class="d-flex px-2 align-center" style="width:170px">
								<v-text-field v-model="localData.mobileOtp" maxlength="5" label="کد تایید" />
								<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP" :loading="optLoading"><small>ارسال کد</small></v-btn>
								<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
							</div> -->
						</v-card>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>

		<v-divider></v-divider>

		<v-card-actions class="d-flex align-center justify-center">
			<v-btn @click="$emit('close')">انصراف</v-btn>
			<v-btn v-if="[USER_TYPES.admin].includes(userType)" color="primary" @click="submitFactor" :loading="submitLoading">
				ثبت صورتحساب
			</v-btn>
			<v-btn v-if="localData" color="info" outlined @click="print()">
				<v-icon>mdi-printer</v-icon>
				چاپ
			</v-btn>
		</v-card-actions>
		<confirm-dlg ref="confirm" />
	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { cloneDeep } from 'lodash'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { emptyId } from '@/util/emptyId'

	const USER_TYPES = {
		admin: 'admin',
		agent: 'agent',
		member: 'member'
	}

	export default {
		name: 'AgentFactorModifyComponent',
		props: {
			data: { type: Object },
			userType: { type: String }
		},
		components: {
			'date-picker': VuePersianDatetimePicker,
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				emptyId: emptyId,
				USER_TYPES: USER_TYPES,
				localData: { member: {} },
				loading: false,
				submitLoading: false,
				datePickerValidatioin: '',
				errorMessages: '',
				sendCodeVisible: true,
				optLoading: false
			}
		},
		mounted() {
			if (this.data) {
				this.localData = cloneDeep(this.data)
			}
		},
		methods: {
			async submitFactor() {
				if (!this.$refs.formFactor.validate()) {
					toast.error('لطفا ابتدا تمام موارد فرم را تکمیل نمایید.')
					return
				}
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از ثبت این صورتحساب مطمئن هستید؟',
				)) {
					this.submitLoading = true
					api.post(`admin/AgentFactor/${this.localData.id === emptyId ? 'Create' : 'Edit'}`, this.localData)
						.then(
							response => {
								toast.success('صورتحساب با موفقیت ذخیره شد.')
								this.localData = response
								this.$emit('close')
							})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => {
							this.submitLoading = false
						})
				}
			},
			print() {
				this.$emit('print', this.localData)
			},
			countDownFinished() {
				this.sendCodeVisible = true
			},
			sendOTP() {
				if (!this.localData.member.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.optLoading = true
				api.post('account/SendWalletWithdrawOTP', this.localData)
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.optLoading = false
					})
			},
		},
	}
</script>
<style></style>
